<div class="mb-4">
	<h4>Filterable values</h4>
	<p>Bulk update all acc application and acc lead filterable values</p>
	<common-button-row>
		<button (click)="bulkUpdateAccApplicationFilterableValues()" class="btn btn-secondary">Bulk update all Acc
			Applications FilterableValues</button>
		<button (click)="bulkUpdateAccLeadFilterableValues()" class="btn btn-secondary">Bulk update all Acc Lead
			FilterableValues</button>
	</common-button-row>
	<p style="color: green;">{{message()}}</p>
</div>

<hr>

<button (click)="refreshAccProspectsForAllTrimesters()" class="btn btn-secondary">Refresh Acc Prospects for all trimesters</button>

<hr>

<div>
	<h4>Alignment</h4>
	<p><strong>THIS IS FOR TEST ONLY:</strong>
		Please select the trimester you want to run the alignemnt matches for. NOTE: This deletes existing records and
		adds new records.</p>
	<div style="width: 20%;" class="mb-2">
		<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
	</div>
	<common-button-row>
		<button (click)="setAccByApplication()" class="btn btn-secondary">Set Accelerator by Application for trimester:
			{{selectedTrimester()?.trimesterId ?? 'current trimester'}}</button>
		<button (click)="setAccByLead()" class="btn btn-secondary">Set Accelerator by Lead for trimester:
			{{selectedTrimester()?.trimesterId ?? 'current trimester'}}</button>
		<button (click)="setCommitmentByApplication()" class="btn btn-secondary">Set Commitment by Application for
			trimester:
			{{selectedTrimester()?.trimesterId ?? 'current trimester'}}</button>
		<button (click)="setCommitmentByLead()" class="btn btn-secondary">Set Commitment by Lead for trimester:
			{{selectedTrimester()?.trimesterId ?? 'current trimester'}}</button>
		<button (click)="refreshAccProspects()" class="btn btn-secondary">Refresh Acc Prospects for trimester:
			{{selectedTrimester()?.trimesterId ?? 'current trimester'}}</button>
	</common-button-row>
</div>

<hr>

<div>
	<h4>Dialogs</h4>

	<common-button-row>
		<button class="btn" (click)="showDialog('Confirm')">Confirm</button>
		<button class="btn" (click)="showDialog('LongText')">Long Message</button>
		<button class="btn" (click)="showDialog('Custom')">Custom</button>
		<button class="btn" (click)="showDialog('Custom-Sized')">Custom Sized</button>
		<button class="btn" (click)="showVenueDialog(1)">Venue Dialog</button>
	</common-button-row>
</div>

<hr>

<div>
	<h4>LMI Data</h4>

	<p>Select what year to regenerate lmi data for. This can be used when adding historical HUD data, for users who
		already have entered in their income information.</p>
	<div style="width: 20%;" class="mb-2">
		<droplist class="year-droplist" [items]='years' (selectionChange)='setYear($event?.uniqueId)'>
		</droplist>
	</div>

	<common-button-row>
		<button (click)="getMissingHUDDataCount()" class="btn btn-secondary" [disabled]="!selectedYear">Get the count of
			records missing HUD data for
			{{ selectedYear }}</button>
		@if (!!lmiMessage) {<p style="color: red;">{{lmiMessage()}}</p>}
	</common-button-row>

	@if (countOfMissingHudData() != undefined) {<p>There are {{countOfMissingHudData()}} people for {{selectedYear}}
		with no
		HUD data.</p>}

	@if(!!countOfMissingHudData()){
	<common-button-row>
		<button (click)="regenerateLMIData()" class="btn btn-secondary"
			[disabled]="!selectedYear || countOfMissingHudData() == 0">Regenerate
			Data</button>
	</common-button-row>
	}
</div>

<hr>

<div class="mb-2">
	<h4>Wistia Video Lengths</h4>
	<div style="width: 10%;">
		<common-wistia-player [video]="{ wistiaId: '4u3xu9uuhy' }"></common-wistia-player>
	</div>
	@if(!loaded()){
	<button class="btn" (click)="getWistiaVideoActivities()" [disabled]="getVideoClicked()">Get Video
		Activities</button>
	}
	@else if(videoActivities().length){
	<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
		<tr>
			<th>Video Activity Id</th>
			<th>Wistia Id</th>
			<th>Title</th>
			<th>Course Versions</th>
			<th>Time In Seconds</th>
			<th>API Time In Seconds</th>
			<th>Update</th>

		</tr>
		@for(activity of videoActivities(); track activity.courseVideoActivityId) {
		<tr>
			<td>{{activity.courseVideoActivityId}}</td>
			<td>{{activity.wistiaId}}</td>
			<td>{{activity.title}}</td>
			<td>{{activity.couserVersionIds}}</td>
			<td [class.color-darkred]='activity.timeInSeconds !== activity.apiTimeInSeconds'>{{activity.timeInSeconds}}
			</td>
			<td [class.color-darkred]='activity.timeInSeconds !== activity.apiTimeInSeconds'>
				{{activity.apiTimeInSeconds}}</td>
			<td>
				@if(activity.apiTimeInSeconds != activity.timeInSeconds){
				<button class="btn"
					(click)="updateActivitiesTimeInSeconds(activity.courseVideoActivityId, activity.apiTimeInSeconds)"
					[disabled]="updateVideoClicked()">Update</button>
				}
				@else {
				<i>Updated</i>
				}
			</td>
		</tr>
		}
	</table>
	}
	@else {
	<div class="color-darkgray"><i>All videos are in sync with the Wistia API timeInSeconds.</i> </div>
	}

</div>
<hr>

<div>
	<p>Update trimesterSwitchoverOldStatusId and insert status logs for acc Applications of 26T1 trimester that are Abandoned,Denied and moved to Cohort during switchover</p>

	<common-button-row>
		<button (click)="updateAccAppSwitchoverStatusId()" class="btn btn-secondary">Update AccApplication Switchover Status IDs</button>
	</common-button-row>

</div>

<hr>

<div>
	<button class="btn" (click)="testTableHelpers()">Test Table Helpers</button>
</div>

<hr>

<div>
	<p>This button migrates old data to new tables, populates historic table and deletes the old tables.</p>
	<button class="btn" (click)="migrateData()" [disabled]="!!oldDataMigrationMessage()">Migrate data</button>
	<p>{{oldDataMigrationMessage()}}</p>
</div>

<hr>

<div>
	<p>Move all dropout data to the new dropout table and update the corresponding accVenture and accMentor records with the new dropout IDs.</p>
	<p>AND also cleans up Address data.</p>
	<button class="btn" (click)="migrateDropoutAndAddressData()">Update dropout and address data</button>
</div>